import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const LOGO_URL = 'https://customer-assets.emergentagent.com/job_b71b88a0-de31-4e82-b047-c99df2477168/artifacts/7dlw52ts_logo%20%281%29.jpg';

export default function PlatformSetupPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState('loading'); // loading, phone, otp, password, done, expired
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [waSent, setWaSent] = useState(false);

  useEffect(() => {
    checkStatus();
  }, []);

  const checkStatus = async () => {
    try {
      const res = await fetch(`${API_URL}/api/setup/status`);
      const data = await res.json();
      if (data.setup_complete) {
        setStep('expired');
      } else {
        setStep('phone');
      }
    } catch {
      setStep('phone');
    }
  };

  const handleSendOTP = async (e) => {
    e.preventDefault();
    if (!name.trim() || !phone.trim()) {
      setError('Naam aur Phone number daalein');
      return;
    }
    const cleanPhone = phone.replace(/\D/g, '').slice(-10);
    if (cleanPhone.length !== 10) {
      setError('Valid 10-digit phone number daalein');
      return;
    }

    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_URL}/api/setup/send-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: cleanPhone, name })
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setWaSent(data.whatsapp_sent);
        setStep('otp');
      } else {
        setError(data.detail || 'OTP bhejne mein error');
      }
    } catch {
      setError('Network error. Try again.');
    }
    setLoading(false);
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    if (!otp || otp.length !== 6) {
      setError('6-digit OTP daalein');
      return;
    }
    if (!password || password.length < 6) {
      setError('Password kam se kam 6 characters ka hona chahiye');
      return;
    }
    if (password !== confirmPassword) {
      setError('Dono passwords match nahi kar rahe');
      return;
    }

    setLoading(true);
    setError('');
    try {
      const cleanPhone = phone.replace(/\D/g, '').slice(-10);
      const res = await fetch(`${API_URL}/api/setup/verify-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: cleanPhone, otp, password, name })
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setStep('done');
      } else {
        setError(data.detail || 'OTP verify nahi hua');
      }
    } catch {
      setError('Network error. Try again.');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-green-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Shiksha Mitra" className="h-16 w-16 mx-auto rounded-xl shadow-lg mb-3" />
          <h1 className="text-2xl font-bold text-gray-800">शिक्षा मित्र</h1>
          <p className="text-sm text-gray-500">Platform Admin Setup</p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">

          {/* EXPIRED */}
          {step === 'expired' && (
            <div className="p-8 text-center" data-testid="setup-expired">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2">Setup Link Expired</h3>
              <p className="text-gray-500 text-sm mb-6">Platform Admin pehle se ban chuka hai. Ye one-time link ab kaam nahi karega.</p>
              <button onClick={() => navigate('/login')} className="px-6 py-3 bg-orange-500 text-white rounded-xl font-semibold hover:bg-orange-600 transition" data-testid="goto-login">
                Login Page par Jaayein
              </button>
            </div>
          )}

          {/* LOADING */}
          {step === 'loading' && (
            <div className="p-8 text-center">
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-orange-500 mx-auto"></div>
              <p className="text-gray-400 mt-4 text-sm">Checking...</p>
            </div>
          )}

          {/* STEP 1: Phone + Name */}
          {step === 'phone' && (
            <div data-testid="setup-phone-step">
              <div className="bg-gradient-to-r from-orange-500 to-orange-600 px-6 py-5 text-white">
                <h3 className="text-lg font-bold">Platform Admin Signup</h3>
                <p className="text-sm text-white/80 mt-1">WhatsApp par OTP aayega</p>
              </div>
              <form onSubmit={handleSendOTP} className="p-6 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Aapka Naam *</label>
                  <input
                    type="text" value={name} onChange={(e) => setName(e.target.value)}
                    placeholder="Jaise: Vikas Garg"
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                    data-testid="setup-name" required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">WhatsApp Number *</label>
                  <input
                    type="tel" value={phone} onChange={(e) => setPhone(e.target.value)}
                    placeholder="10-digit number"
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                    data-testid="setup-phone" required
                  />
                </div>

                {error && <div className="bg-red-50 text-red-600 text-sm px-4 py-2 rounded-lg" data-testid="setup-error">{error}</div>}

                <button type="submit" disabled={loading}
                  className="w-full py-3.5 bg-orange-500 text-white rounded-xl font-bold text-lg hover:bg-orange-600 transition disabled:opacity-50"
                  data-testid="setup-send-otp">
                  {loading ? 'Bhej rahe hain...' : 'WhatsApp par OTP Bhejein'}
                </button>
                <p className="text-center text-xs text-gray-400">One-time setup link. Sirf pehla admin ban sakta hai.</p>
              </form>
            </div>
          )}

          {/* STEP 2: OTP + Password */}
          {step === 'otp' && (
            <div data-testid="setup-otp-step">
              <div className="bg-gradient-to-r from-green-500 to-green-600 px-6 py-5 text-white">
                <h3 className="text-lg font-bold">OTP Verify Karein</h3>
                <p className="text-sm text-white/80 mt-1">
                  {waSent ? `WhatsApp par OTP bheja gaya: ${phone}` : `OTP bhejne mein issue. Phone check karein: ${phone}`}
                </p>
              </div>
              <form onSubmit={handleVerifyOTP} className="p-6 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">6-Digit OTP *</label>
                  <input
                    type="text" value={otp} onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                    placeholder="123456" maxLength={6}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 text-center text-2xl tracking-widest font-mono"
                    data-testid="setup-otp-input" required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Naya Password Set Karein *</label>
                  <input
                    type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                    placeholder="Kam se kam 6 characters"
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500"
                    data-testid="setup-password" required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Password Confirm Karein *</label>
                  <input
                    type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Wahi password dobara"
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500"
                    data-testid="setup-confirm-password" required
                  />
                </div>

                {error && <div className="bg-red-50 text-red-600 text-sm px-4 py-2 rounded-lg" data-testid="setup-error">{error}</div>}

                <button type="submit" disabled={loading}
                  className="w-full py-3.5 bg-green-500 text-white rounded-xl font-bold text-lg hover:bg-green-600 transition disabled:opacity-50"
                  data-testid="setup-verify-btn">
                  {loading ? 'Verify ho raha hai...' : 'OTP Verify + Account Banayein'}
                </button>

                <button type="button" onClick={() => { setStep('phone'); setError(''); setOtp(''); }}
                  className="w-full text-sm text-gray-400 hover:text-gray-600">
                  Dobara OTP Bhejein
                </button>
              </form>
            </div>
          )}

          {/* DONE */}
          {step === 'done' && (
            <div className="p-8 text-center" data-testid="setup-done">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Platform Admin Ban Gaya!</h3>
              <p className="text-gray-500 text-sm mb-2">Aapka account successfully create ho gaya hai.</p>
              <div className="bg-gray-50 rounded-xl p-4 mb-6 text-left border border-dashed border-gray-300">
                <p className="text-xs text-gray-500 mb-2 font-bold uppercase">Your Login:</p>
                <p className="text-sm"><span className="text-gray-500">Phone:</span> <strong>{phone}</strong></p>
                <p className="text-sm"><span className="text-gray-500">Password:</span> <strong>Jo aapne set kiya</strong></p>
              </div>
              <button onClick={() => navigate('/login')}
                className="w-full py-3.5 bg-orange-500 text-white rounded-xl font-bold text-lg hover:bg-orange-600 transition"
                data-testid="setup-goto-login">
                Abhi Login Karein →
              </button>
            </div>
          )}
        </div>

        <p className="text-center text-xs text-gray-400 mt-6">शिक्षा मित्र — System Of Success</p>
      </div>
    </div>
  );
}
